import React from 'react';
import {createStackNavigator, StackScreenProps} from '@react-navigation/stack';

import {Screens, Routes} from './model';
import {ProfileNotificationSettings} from '../../screens/profile/mobile/components/notifications';
import {ProfileMobile} from '../../screens/profile/mobile';
import {DesktopProfileSettings} from '../../screens/profile/desktop/components/settings';
import {ProfileUserContacts} from '../../screens/profile/mobile/components/contacts';
import {ProfileApplications} from '../../screens/profile/common/applications';
import {ProfileChangePassword, ProfileCreatePassword} from '../../screens/profile/common/changePassword';
import {ProfileBaseInfo} from '../../screens/profile/mobile/components/baseInfo';
import {useTheme} from '../theme';
import {ProfileScreen} from '../../screens/profile';
import {ProfileApplicationsItemMobile} from '../../screens/profile/mobile/components/applications/item';
import {ProfileApplicationsItemResolver, ProfileApplicationsResolver} from '../resolvers/applications';
import {createRootScreenOptions, createProfileChildScreenOptions} from './topBar';
import {ProfileApplicationsFilterMobile} from '../../screens/profile/mobile/components/applicationsFilter';
import {ProfileUserPhoneConfirmation} from '../../screens/profile/mobile/components/phoneConfirmation';
import {ProfileUserEmailConfirmation} from '../../screens/profile/mobile/components/emailConfirmation';
import {ProfileSafety} from '../../screens/profile/mobile/components/safety';
import {useSelector} from 'react-redux';
import {holderProfileSelector} from '../../redux/selectors/profile';
import {UscType} from '../models/profile/uscType';
import {CardStatus} from '../../types/enums/cardStatus';
import {TouchableOpacity, View} from 'react-native';
import {images} from '../../assets/icons';
import {useStyles} from '../hooks/styles';
import {Settings} from '../constants/config';
import {LinkedAccounts} from '../../screens/profile/desktop/components/linkedAccounts';
import {ProfileLinkedAccounts} from '../../screens/profile/mobile/components/linkedAccounts/view';
import {ProfileLinkedAccountsItem} from '../../screens/profile/mobile/components/linkedAccounts/item/view';
import {ProfileLinkedAccountsLinkAccount} from '../../screens/profile/mobile/components/linkedAccounts/inputForm/inputForm';
import {useNavigation} from '@react-navigation/native';
import {UserCardListMobile} from '../../screens/login/esiaRegCard/components/form/components/userCardList/mobile/view';
import {EsiaRegCardFormMobile} from '../../screens/login/esiaRegCard/components/form/mobile';
import {EsiaRegCardMap} from '../../screens/login/esiaRegCard/components/map';
import esiaActivateCardAfterLoggedOnMobile from '../../screens/login/esiaActivateCard/esiaActivateCardAfterLoggedOnMobile/esiaActivateCardAfterLoggedOnMobile';
import {esiaRegistrationInfoSelector} from '../../redux/selectors/login';
import {EsiaLoginAfterLogged} from '../../screens/login/esiaRegCard/components/EsiaLoginAfterLogged/esiaLoginAfterLogged';
import {MobilePasswordCreation} from '../../screens/profile/mobile/components/passwordCreationForm/MobilePasswordCreation';
import {DocumentsListItem} from '../../screens/profile/mobile/components/documents/listItem';

const MobileStack = createStackNavigator();
export const MobileProfileNavigation = (props: StackScreenProps<any>) => {
  const nav = useNavigation();
  const holderProfile = useSelector(holderProfileSelector());
  const esiaRegInfo = useSelector(esiaRegistrationInfoSelector);
  const hasEsiaRegInfo = !!esiaRegInfo;
  const isFinancialCard = holderProfile?.uscType === UscType.Financial;
  const isActiveCard = holderProfile?.cardStatusId === CardStatus.Active;
  const theme = useTheme();

  const styles = useStyles(() => {
    return {
      rightContainer: {
        color: theme.color.labelText,
        borderWidth: 2,
        borderColor: theme.color.labelText,
        width: 36,
        height: 36,
        borderRadius: 18,
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: 6,
      },
      rightColor: {
        color: theme.color.labelText,
      },
    };
  });
  return (
    <MobileStack.Navigator initialRouteName={Screens.ProfileMenu}>
      <MobileStack.Screen
        options={createRootScreenOptions(
          theme,
          `Мой профиль${Settings.getIsTest() ? '(Тестовый)' : ''}`,
          props.navigation,
        )}
        name={Screens.ProfileMenu}
        component={ProfileMobile}
      />
      <MobileStack.Screen
        options={createProfileChildScreenOptions(theme, 'Общая информация')}
        name={Screens.ProfileBaseInfo}
        component={ProfileBaseInfo}
      />
      <MobileStack.Screen
        options={({navigation}) =>
          createProfileChildScreenOptions(
            theme,
            'Мои заявления',
            Screens.ProfileMenu,
            <TouchableOpacity
              testID='profile-applications-id'
              onPress={() => {
                if (hasEsiaRegInfo) {
                  navigation.navigate(Screens.EsiaRegistrationCardUserSelecting as any);
                } else {
                  navigation.navigate(Screens.EsiaLoginAfterLogged as any);
                }
              }}>
              <View style={styles.rightContainer as any}>
                <images.Plus color={styles.rightColor.color} height={24} width={24} />
              </View>
            </TouchableOpacity>,
          )
        }
        name={Screens.ProfileApplications}
        component={ProfileApplicationsResolver(ProfileApplications)}
      />
      <MobileStack.Screen
        options={createProfileChildScreenOptions(theme, 'Заявление', Screens.ProfileApplications)}
        name={Screens.ProfileApplicationsItem}
        component={ProfileApplicationsItemResolver(ProfileApplicationsItemMobile)}
      />
      <MobileStack.Screen
        options={createProfileChildScreenOptions(theme, 'Мои документы')}
        name={Screens.ProfileUserDocuments}
        component={DocumentsListItem}
      />
      <MobileStack.Screen
        options={createProfileChildScreenOptions(theme, 'Контактные данные', Screens.ProfileMenu)}
        name={Screens.ProfileConfirmation}
        component={ProfileUserContacts as React.ComponentType<any>}
      />
      <MobileStack.Screen
        options={createProfileChildScreenOptions(theme, 'Контактные данные', Screens.ProfileMenu)}
        name={Screens.ProfileUserContacts}
        component={ProfileUserContacts as React.ComponentType<any>}
      />
      <MobileStack.Screen
        options={createProfileChildScreenOptions(theme, 'Подтвердите новый номер')}
        name={Screens.ProfileUserPhoneConfirmation}
        component={ProfileUserPhoneConfirmation}
      />
      <MobileStack.Screen
        options={createProfileChildScreenOptions(theme, 'Подтвердите новую эл. почту', Screens.ProfileMenu)}
        name={Screens.ProfileUserEmailConfirmation}
        component={ProfileUserEmailConfirmation}
      />
      <MobileStack.Screen
        options={({navigation}) =>
          createProfileChildScreenOptions(
            theme,
            'Фильтр',
            Screens.ProfileApplications,
            <TouchableOpacity
              testID='profile-applications-id'
              onPress={() => {
                if (navigation.canGoBack()) {
                  navigation.goBack();
                } else {
                  navigation.navigate(Screens.ProfileApplications as any);
                }
              }}>
              <View style={styles.rightContainer as any}>
                <images.Check color={styles.rightColor.color} height={24} width={24} />
              </View>
            </TouchableOpacity>,
          )
        }
        name={Screens.ProfileApplicationsFilter}
        component={ProfileApplicationsFilterMobile}
      />
      <MobileStack.Screen
        options={createProfileChildScreenOptions(theme, 'Настройка уведомлений')}
        name={Screens.ProfileNotificationSettings}
        component={ProfileNotificationSettings}
      />
      <MobileStack.Screen
        options={({navigation}) =>
          createProfileChildScreenOptions(
            theme,
            'Связанные аккаунты',
            Screens.ProfileMenu,
            <TouchableOpacity
              testID='profile-linked-accounts-add-id'
              onPress={() => {
                navigation.navigate(Screens.ProfileLinkedAccountsLinkAccount as any);
              }}>
              <View style={styles.rightContainer as any}>
                <images.Plus color={styles.rightColor.color} height={24} width={24} />
              </View>
            </TouchableOpacity>,
          )
        }
        name={Screens.ProfileLinkedAccounts}
        component={ProfileLinkedAccounts}
      />
      <MobileStack.Screen
        options={createProfileChildScreenOptions(theme, 'Связать аккаунт', Screens.ProfileLinkedAccounts)}
        name={Screens.ProfileLinkedAccountsLinkAccount}
        component={ProfileLinkedAccountsLinkAccount}
      />
      <MobileStack.Screen
        options={createProfileChildScreenOptions(theme, 'Аккаунт', Screens.ProfileLinkedAccounts)}
        name={Screens.ProfileLinkedAccountsItem}
        component={ProfileLinkedAccountsItem}
      />
      <MobileStack.Screen
        options={createProfileChildScreenOptions(theme, 'Изменение пароля')}
        name={Screens.ProfileChangePassword}
        component={ProfileChangePassword}
      />
      {!(isFinancialCard && isActiveCard) && (
        <MobileStack.Screen
          options={createProfileChildScreenOptions(theme, 'Безопасность')}
          name={Screens.ProfileSafety}
          component={ProfileSafety}
        />
      )}
      <MobileStack.Screen
        options={createProfileChildScreenOptions(theme, 'Активировать карту', Screens.ProfileLinkedAccountsItem)}
        name={Screens.EsiaActivateCardAfterLogged}
        component={esiaActivateCardAfterLoggedOnMobile}
      />
      <MobileStack.Screen
        options={createProfileChildScreenOptions(theme, 'Оформить нефинансовую карту', Screens.ProfileApplications)}
        name={Screens.EsiaRegistrationCardUserSelecting}
        component={UserCardListMobile}
      />
      <MobileStack.Screen
        options={({route}) =>
          createProfileChildScreenOptions(
            theme,
            'Оформление нефинансовой ЕСК',
            (route.params as {fromReissue?: boolean} | undefined)?.fromReissue
              ? Screens.CardReissue
              : Screens.ProfileApplications,
          )
        }
        name={Screens.EsiaRegistrationCard}
        component={EsiaRegCardFormMobile}
      />
      <MobileStack.Screen
        options={createProfileChildScreenOptions(theme, 'Оформление нефинансовой ЕСК')}
        name={Screens.EsiaRegistrationCardMap}
        component={EsiaRegCardMap as React.ComponentType<any>}
      />
      <MobileStack.Screen
        options={({route}) =>
          createProfileChildScreenOptions(
            theme,
            'Оформление нефинансовой ЕСК',
            (route.params as {fromReissue?: boolean} | undefined)?.fromReissue
              ? Screens.CardReissue
              : Screens.ProfileApplications,
          )
        }
        name={Screens.EsiaLoginAfterLogged}
        component={EsiaLoginAfterLogged}
      />
      <MobileStack.Screen
        options={createProfileChildScreenOptions(theme, 'Создание пароля', Screens.ProfileMenu)}
        name={Screens.ProfileCreatePassword}
        component={MobilePasswordCreation}
      />
    </MobileStack.Navigator>
  );
};

const ProfileRedirect = ({navigation}: StackScreenProps<any>) => {
  React.useEffect(() => navigation.navigate(Screens.DesktopProfileMe), []);
  return null;
};

export const desktopRoutes = [
  {
    route: Screens.Profile,
    webRoute: Routes.profile,
    component: ProfileRedirect,
  },
  {
    title: `Профиль${Settings.getIsTest() ? '(Тестовый)' : ''}`,
    route: Screens.DesktopProfileMe,
    webRoute: Routes.profileMe,
    component: ProfileScreen,
  },
  {
    title: `Связанные аккаунты`,
    route: Screens.DesktopProfileLinkedAccounts,
    webRoute: Routes.profileLinkedAccounts,
    component: LinkedAccounts,
  },
  {
    title: 'Настройки',
    route: Screens.DesktopProfileSettings,
    webRoute: Routes.profileSettings,
    component: DesktopProfileSettings,
  },
  {
    title: 'Настройки',
    route: Screens.ProfileConfirmation,
    webRoute: Routes.profileConfirmation,
    component: DesktopProfileSettings,
  },
  {
    title: 'Изменение пароля',
    route: Screens.ProfileChangePassword,
    webRoute: Routes.profileChangePassword,
    component: ProfileChangePassword,
  },
  {
    route: Screens.ProfileApplications,
    webRoute: Routes.profileApplications,
    component: ProfileApplicationsResolver(ProfileApplications),
    title: 'Мои заявления',
  },
  {
    title: 'Создание пароля',
    route: Screens.ProfileCreatePassword,
    webRoute: Routes.profileCreatePassword,
    component: ProfileCreatePassword,
  },
];
